import { render, staticRenderFns } from "./GraduatesSingleAssessment.vue?vue&type=template&id=22aaaab1&"
import script from "./GraduatesSingleAssessment.vue?vue&type=script&lang=js&"
export * from "./GraduatesSingleAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports